import React from "react";
import userIcon from "./img/user-ico.svg";
import searchIcon from "./img/search-ico.svg";

// The slot on the right of the top bar. The Containerize.Menu engine filled it from the
// shared `UserInfo` cookie: empty box when signed out, account dropdown + search when
// signed in. This is that same logic, ported so it no longer needs the remote script.
//
// Note this is the *Aspose account* cookie, unrelated to this app's own Keycloak session
// (see ./AppLogin) - signing in there does not populate it.

const COOKIE = "UserInfo";

const readCookie = (name) => {
    const prefix = name + "=";
    const parts = decodeURIComponent(document.cookie).split(";");
    for (let part of parts) {
        part = part.trimStart();
        if (part.indexOf(prefix) === 0) return part.substring(prefix.length);
    }
    return "";
};

// The cookie holds base64 of "name=<login>&nick=<display name>&...". Display the nickname
// when there is one, otherwise the login. Anything unexpected means "signed out".
const readUserName = () => {
    try {
        const raw = readCookie(COOKIE);
        if (!raw) return null;
        const bytes = Uint8Array.from(atob(raw), c => c.charCodeAt(0));
        const decoded = new TextDecoder().decode(bytes);
        const fields = decoded.split("&");
        const login = (fields[0] || "").split("=")[1];
        const nick = (fields[1] || "").split("=")[1];
        return nick || login || null;
    } catch (e) {
        return null;
    }
};

const ACCOUNT_LINKS = [
    {label: "Dashboard", icon: "fa-th-large", href: "https://dashboard.aspose.cloud"},
    {label: "My Apps", icon: "fa-inbox", href: "https://dashboard.aspose.cloud/applications"},
    {label: "My Usage", icon: "fa-align-left", href: "https://dashboard.aspose.cloud/billing/api-usage"},
    {label: "Account Settings", icon: "fa-cog", href: "https://id.containerize.com/admin#/settings/profile/general"}
];

const UserControls = () => {
    // Cookies are unavailable during SSR, so the signed-out box is what gets pre-rendered
    // and the account menu appears on hydration - same as the old script-injected markup.
    const [userName, setUserName] = React.useState(null);

    React.useEffect(() => {
        setUserName(readUserName());
    }, []);

    if (!userName) {
        return <div className="userloginbox desklink"/>;
    }

    return (
        <>
            <div className="userloginbox usersignout desklink">
                <ul className="loginanchor loggeduser">
                    <li>
                        <a href="#" className="userlogin" onClick={(e) => e.preventDefault()}>
                            <img src={userIcon} alt="User" width="24" height="24"/>
                            <span className="font-0">User</span>
                        </a>
                        <ul>
                            <li>
                                <a id="UserNameLink" className="topurlink topusernamelink moblink">{userName}</a>
                            </li>
                            {ACCOUNT_LINKS.map(link => (
                                <li key={link.href}>
                                    <a href={link.href} className="topurlink topaccount moblink">
                                        <i className={"fa " + link.icon}/> {link.label}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <a href="https://forum.aspose.cloud/session/logout"
                                   className="topurlink toplogout moblink">
                                    <i className="fa fa-sign-out"/> Sign out
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="topsearchboxdiv">
                <a className="topsearchbtn" href="https://search.aspose.cloud">
                    <img src={searchIcon} alt="Search" width="24" height="24"/>
                    <span className="font-0">Search</span>
                </a>
            </div>
        </>
    );
};

export default UserControls;
